import AreaResourcesContainer from './AreaResourcesContainer';
export default AreaResourcesContainer;